// @flow
import React, { Component } from 'react'
import cloneDeep from 'lodash.clonedeep'
import { get } from 'axios'
import moment from 'moment'
import { Row, Col, Collapse, Input, Card, Button, Icon, Modal, Slider, Spin } from 'antd'
import { getMarketPrices } from '../../actions/portfolios'
import ChartRisk2 from '../chart-risk/chartRisk2'
import TableRiskSelected from '../table-risk-selected'
import IvTable from './IvTable'
import { StyledContent } from './style'
import {
  impliedVolatilityRiskProfile,
  xAxisMinMax,
  calcEntryCost,
  optionPricesWithoutPromise,
} from '../../services/risk'
const Panel = Collapse.Panel;

class RiskProfileComponent extends Component {
  
  state = {
    isRiskProfileLoading: true,
    isRiskProfileEmpty: true,
    scenarios: [
      {
        name: 'Default',
        expireDate: moment(),
        ivData: {},
      },
    ],
    isLoading: true,
    checkedList: [],
    assetPrice: 150,
    priceDifference: null,
    prevPriceDifference: null,
    mainExpireDate: moment(),
    minTransactionDate: moment(),
    dates: [],
    scenarioIndex: -1,
    tranIndex: -1,
    isIVChart: false,
    sliderRange: 0,
    marketPrices: {},
    isDirty: false,
    selectedTrade: this.props.selectedTrade,
  }
  
  async componentWillMount() {
    // validate that data is ready to be added to chart
    if (this.props.selectedTrade) {
      const marketPrices = await this.getPrices();
      this.setState({marketPrices,});
      this.loadRiskChartData(marketPrices)
    }
  }
  
  componentWillUnmount() {
    if (this.interval) {
      window.clearInterval(this.interval);
    }
  }
  
  getPrices = async () => {
    try {
      const {
        selectedTrade
      } = this.props;
      
      // add expire day count to all trades trade legs
      if (!selectedTrade) {
        return;
      }
      const tradeRecord = cloneDeep(selectedTrade);
      if (tradeRecord && tradeRecord.transactions) {
        const symbols = tradeRecord.transactions.map(x => x.symbol).filter(x => x);
        const uniqSymbols = []
        symbols.forEach(x => {
            if (!uniqSymbols.find(y => y.s === x)) {
              uniqSymbols.push({s:x, d: moment().format('YYYY-MM-DD')});
            }
          }
        );
        if (uniqSymbols.length) {
          const marketPriceRes = await getMarketPrices(uniqSymbols);
          if (marketPriceRes && marketPriceRes.data && marketPriceRes.data.data && marketPriceRes.data.data.securities && marketPriceRes.data.data.securities.options) {
            return marketPriceRes.data.data.securities.options;
          }
        }
      }
      return {};
    } catch(err) {
      return {};
    }
  }
  
  getPortfolioSnapshot = () => {
    this.props.getPortfoliosList()
  }
  
  loadRiskChartData = async (marketPrices) => {
    const {
      selectedTrade
    } = this.props
    let assetPrice = 100;
    // add expire day count to all trades trade legs
    if (!selectedTrade) {
      return;
    }
    const tradeRecord = cloneDeep(selectedTrade);
    const data = await get(`https://cloud.iexapis.com/v1/stock/${selectedTrade.symbols}/quote?token=pk_ff59a3b39cf04827aed30a4797e5a6f0`).catch(er=>{})
    if (data && data.data) {
      assetPrice = data.data.latestPrice;
    }
    
    const xAxis = xAxisMinMax(selectedTrade.transactions)
    const scenarios = this.state.scenarios;
    
    let minTransactionDate = null;
    let maxTransactionDate = null;
    const checkedList = [];
    selectedTrade.transactions.forEach((t,i)=> {
      if (minTransactionDate === null || minTransactionDate.isAfter(t.expiration)) {
        minTransactionDate = moment(t.expiration);
      }
      if (maxTransactionDate === null || maxTransactionDate.isBefore(t.expiration)) {
        maxTransactionDate = moment(t.expiration);
      }
      tradeRecord.transactions[i].expireDayCount = moment(t.expiration).diff(moment(), 'days')
      if (marketPrices[t.symbol]) {
        const mkPrice = (((marketPrices[t.symbol].ask || 0) + (marketPrices[t.symbol].bid || 0)) / 2).toFixed(2);
        tradeRecord.transactions[i].marketPrice = mkPrice;
        tradeRecord.transactions[i].underlyingPrice = marketPrices[t.symbol].underlyingPrice;
        t.marketPrice = mkPrice;
      }
      checkedList.push(i);
    });
    const dates = [moment(selectedTrade.openDate).format('YYYY-MM-DD')];
    if (maxTransactionDate) {
      const currDate = moment(selectedTrade.openDate);
      const lastDate = maxTransactionDate;
      if (currDate.isBefore(lastDate)) {
        while(currDate.add(1, 'days').diff(lastDate) < 0) {
          dates.push(currDate.clone().format('YYYY-MM-DD'));
        }
      }
      dates.push(maxTransactionDate.format('YYYY-MM-DD'));
    }
    const dayRange = minTransactionDate.diff(moment(selectedTrade.openDate), 'days');
    const sliderRange = moment().diff(moment(selectedTrade.openDate), 'days');
    scenarios[0].minExpireDate= minTransactionDate;
    this.setState({
      checkedList,
      dayRange,
      dates,
      assetPrice,
      minTransactionDate,
      openDate: selectedTrade.openDate,
      maxTransactionDate,
      tradeRecord: tradeRecord,
      mainExpireDate: moment(selectedTrade.openDate),
      sliderRange,
      todayOpenDiffDays: sliderRange,
    }, ()=> {
      this.setAllYForScenarios(scenarios, selectedTrade, xAxis, true );
    });
  }
  
  setAllYForScenarios = async (scenarios, selectedTrade, xAxis, isFirst) => {
    const {minTransactionDate, tradeRecord, dates} = this.state;
    
    if (isFirst && tradeRecord.transactions && dates) {
      const days = moment().diff(moment(this.state.openDate), 'days');   // diff(moment(this.state.openDate), 'days') + 1;
      const symbols = tradeRecord.transactions.map(x => x.symbol).filter(x => x);
      const uniqSymbols = []
      symbols.forEach(x => {
        if (!uniqSymbols.find(y => y.s === x)) {
          uniqSymbols.push({s:x, d: moment().format('YYYY-MM-DD')});
        }
      });
      for(let j=0; j< days; j++) {
        const date = moment(this.state.openDate).add(j, 'days').format('YYYY-MM-DD');
        const symbols = uniqSymbols.map(x=>({s: x.s, date})); // .map(x=>({s: x.s, d: moment(this.state.openDate).add(j, 'days').format('YYYY-MM-DD')}))
        try {
          const marketPriceRes = await getMarketPrices(symbols);
          if (marketPriceRes && marketPriceRes.data && marketPriceRes.data.data && marketPriceRes.data.data.securities && marketPriceRes.data.data.securities.options) {
            const marketPrices = marketPriceRes.data.data.securities.options || {};
            tradeRecord.transactions.forEach((t,i)=> {
              const symbol = t.symbol;
              if (marketPrices[symbol]) {
                if (!scenarios[0].ivData[i]) {
                  scenarios[0].ivData[i] = []
                }
                dates.forEach((x,j)=> {
                  if (x === date) {
                    const mp = ((marketPrices[symbol].ask || 0) + (marketPrices[symbol].bid || 0)) / 2;
                    const iv = impliedVolatilityRiskProfile({...t, marketPrice: mp}, this.state.assetPrice);
                    scenarios[0].ivData[i][j] = iv.volatility;
                  }
                })
              }
            })
          }
        } catch(err) {}
      }
    }
    
    scenarios.forEach((scenario) => {
      const trade = selectedTrade;
      trade.transactions.forEach((transaction) => {
        transaction.expireDayCount = moment(transaction.expiration).diff(scenario.expireDate, 'days')
      });
      scenario.yAxis = this.loadRiskChart(trade.transactions, xAxis, scenario, isFirst);
      trade.transactions.forEach((transaction) => {
        transaction.expireDayCount = moment(transaction.expiration).diff(minTransactionDate, 'days')
      });
      scenario.yAxis2 = this.loadRiskChart(trade.transactions, xAxis, scenario, false);
    });
    if (isFirst && tradeRecord.transactions && dates) {
      tradeRecord.transactions.forEach((t,i)=> {
        if (!scenarios[0].ivData[i]) {
          scenarios[0].ivData[i] = []
        }
        dates.forEach((x,j)=> {
          if (moment(x).isAfter(moment().add(-1, 'days'))) {
            scenarios[0].ivData[i][j] = t.iv;
          }
        })
      })
    }
    this.setState({
      scenarios,
      xAxis,
      isLoading: false,
      selectedTrade,
    })
  }
  
  loadRiskChart = (transactions, xAxis, scenario, isFirst) => {
    const yAxis = []
    const { checkedList, assetPrice, tradeRecord, dates} = this.state;
    let mainExpireDate = this.state.mainExpireDate;
    if (moment().isAfter(moment(mainExpireDate))) {
      mainExpireDate = moment();
    }
    const dateIndex = dates.findIndex(x=> x === mainExpireDate.format('YYYY-MM-DD'));
    transactions.forEach((transaction, index) => {
      if (checkedList.indexOf(index) === -1) {
        yAxis[index] = [];
      }
      const iv = impliedVolatilityRiskProfile(transaction, assetPrice);
      const entryCost = calcEntryCost(transaction);
      if (scenario.name === 'Default' && isFirst) {
        tradeRecord.transactions[index].iv = iv.volatility;
      }
      if (isFirst) {
        scenario[`values${index}`] = tradeRecord.transactions[index].iv;
      }
      if (scenario[`values${index}`] && !isNaN((scenario[`values${index}`].replace('%','')))) {
        iv.volatility = scenario[`values${index}`];
      }
      if (scenario.ivData && scenario.ivData[index] && dateIndex > -1 && scenario.ivData[index][dateIndex] && !isNaN((scenario.ivData[index][dateIndex].replace('%','')))) {
        iv.volatility =  scenario.ivData[index][dateIndex];
      }
      
      // Get all option prices : Set all yAxis points : Set all price / PL data
      const optionPrice = optionPricesWithoutPromise({ transaction, iv, xAxis, entryCost })
      let allEntryCosts = []
      optionPrice.optionPrices.forEach(({callResult, putResult}) => {
        // create data for new point
        const potentialTransaction = { ...transaction }
        const optionType = transaction.assetType === 'Call' ? callResult : putResult
        potentialTransaction.price = optionType.optionValue
        allEntryCosts = [...allEntryCosts, calcEntryCost(potentialTransaction)]
      })
      // calculate difference between entry and asset point
      let allYChange = []
      allEntryCosts.forEach((cost, i) => {
        const y = Math.round(cost - entryCost)
        allYChange = [...allYChange, y]
        if (i === allEntryCosts.length - 1) {
          yAxis[index] = allYChange;
        }
      })
    })
    const newYAxis = []
    yAxis[0].forEach((ind, index) => {
      let count = 0
      yAxis.forEach((innerY, ind) => {
        if (checkedList.indexOf(ind) > -1) {
          count += innerY[index]
        }
      })
      newYAxis[index] = count;
    });
    return newYAxis;
  }
  
  handleCheckedChange = (checkedList) => {
    this.setState({
      checkedList,
      isDirty: true,
    });
  }
  
  onChange = (e, index, tranIndex) => {
    const { scenarios, todayOpenDiffDays } = this.state
    const scenario = scenarios[index];
    scenario[e.target.name] = e.target.value
    if (!scenario[`unlock${tranIndex}`]) {
      const input = e.target.value;
      const ivData = scenario.ivData || {};
      const newivKeysData = []
      const ivKeysData = ivData[tranIndex] || [];
      ivKeysData.forEach((oldIv, i) => {
        if (i >= todayOpenDiffDays ) {
          newivKeysData.push(input);
        } else {
          newivKeysData.push(oldIv);
        }
      });
      ivData[tranIndex] = newivKeysData;
      scenario[`isCustomIv${tranIndex}`] = false;
      scenario.ivData = ivData;
    }
    this.setState({
      scenarios,
      isDirty: true,
    })
  }
  
  reloadChart = () => {
    const {scenarios, selectedTrade, xAxis, prevPriceDifference, priceDifference} = this.state;
    if (priceDifference !== prevPriceDifference && !isNaN(priceDifference)) {
      const xAxisNew = xAxisMinMax(selectedTrade.transactions, Number(priceDifference))
      this.setState({
        prevPriceDifference: priceDifference,
        isDirty: false,
      });
      
      this.setAllYForScenarios(scenarios, selectedTrade, xAxisNew );
    } else {
      this.setState({
        isDirty: false,
      });
      this.setAllYForScenarios(scenarios, selectedTrade, xAxis );
    }
  }
  
  onChangeValues = (e) => {
    const {name, value} = e.target;
    const { scenarios } = this.state;
    this.setState({
      [name]: value,
      isDirty: true,
    }, () => {
      if (name === 'mainExpireDate') {
        scenarios.forEach(sc=> {
          sc.expireDate = value;
        })
        this.setState({
          scenarios,
        })
      }
    })
  }
  
  onChangeTransactionValues = (name, value, index) => {
    let selectedTrade = this.state.selectedTrade;
    let tradeRecord = this.state.tradeRecord;
    
    selectedTrade.transactions[index] = {
      ... selectedTrade.transactions[index],
      [name]: value,
    }
    tradeRecord.transactions[index] = {
      ...tradeRecord.transactions[index],
      [name]: value,
    }
    
    if (name === 'expiration') {
      tradeRecord.transactions.forEach((transaction) => {
        transaction.expireDayCount = moment(transaction.expiration).diff(this.state.mainExpireDate, 'days')
      });
    }
    
    this.setState({
      tradeRecord,
      selectedTrade,
      isDirty: true,
    });
  }
  
  addScenario = () => {
    const {scenarios, mainExpireDate, tradeRecord, dates, minTransactionDate} = this.state;
    const ivData = {}
    const ivs = {}
    if (tradeRecord.transactions && dates) {
      tradeRecord.transactions.forEach((t,i)=> {
        ivData[i] = []
        dates.forEach((x,j)=> {
          ivData[i][j] = t.iv;
        })
        ivs[`values${i}`] = t.iv;
      })
    }
    scenarios.push({
      name: `scenario ${scenarios.length + 1}`,
      expireDate: mainExpireDate,
      minExpireDate: minTransactionDate,
      yAxis: scenarios[0].yAxis,
      yAxis2: scenarios[0].yAxis2,
      ivData: ivData,
      ...ivs,
    });
    this.setState({
      scenarios,
    })
  }
  
  removeScenarios = (e, index) => {
    const scenarios = this.state.scenarios
    if(index > 0){
      delete scenarios[index]
      this.setState({
        scenarios
      })
    }
  }
  
  openModal = (scenarioIndex, tranIndex) => {
    this.setState({
      scenarioIndex,
      tranIndex,
      showModal: true,
    })
  }
  
  onChangeIV = (e, i) => {
    const { scenarios, scenarioIndex, tranIndex } = this.state
    const scenario = scenarios[scenarioIndex]
    if (!scenario.ivData[tranIndex]) {
      scenario.ivData[tranIndex] = []
    }
    scenario.ivData[tranIndex][i] = e.target.value;
    scenario[`isCustomIv${tranIndex}`] = true;
    scenario[`unlock${tranIndex}`] = true;
    this.setState({
      scenarios,
      isDirty: true,
    })
  }
  
  onPlay = () => {
    const { sliderRange: rangeSlider, dayRange: rangeDay } = this.state;
    if (rangeSlider >= rangeDay) {
      return;
    }
    this.setState({
      isPlay: true,
    })
    
    this.interval = window.setInterval(() => {
      const { sliderRange, dayRange, openDate } = this.state;
      if (dayRange === sliderRange) {
        window.clearInterval(this.interval);
        this.setState({
          isPlay: false,
          sliderRange: 0,
          mainExpireDate: moment(openDate)
        });
        this.changeSlider(0);
        return;
      }
      this.changeSlider((sliderRange || 0) + 1);
    }, 1000)
  }
  
  toggleChart = () => {
    this.setState({
      isIVChart: !this.state.isIVChart,
    })
  }
  
  changeSlider = (val) => {
    const { scenarios, openDate } = this.state;
    const newDate = moment(openDate).add(val, 'days')
    scenarios.forEach(sc=> {
      sc.expireDate = newDate;
    });
    this.setState({
      mainExpireDate: newDate,
      scenarios: scenarios,
      sliderRange: val
    }, () => {
      this.reloadChart()
    });
  }
  
  onPause = () => {
    this.setState({
      isPlay: false,
    });
    if (this.interval) {
      window.clearInterval(this.interval);
    }
  }
  
  getTipFormatter = (value) => {
    if (!this.state.openDate) {
      return ''
    }
    return moment(this.state.openDate).add(value || 0, 'days').format('YYYY-MM-DD');
  }
  
  exportChart = (e) => {
    const can = document.getElementById('canvas_1');
    const target= document.getElementById('download');
    if (can) {
      target.href = can.toDataURL();
      target.download = 'chart.png';
    }
  }
  
  lockUnlock = (status, scenarioIndex, tranIndex) => {
    const { scenarios, todayOpenDiffDays } = this.state
    const scenario = scenarios[scenarioIndex];
    const input = scenario[`values${tranIndex}`]
    scenario[`unlock${tranIndex}`] = !status;
    const ivData = scenario.ivData || {};
    if (status) {
      const newivKeysData = []
      const ivKeysData = ivData[tranIndex] || [];
      ivKeysData.forEach((oldIv, i) => {
        if (i >= todayOpenDiffDays ) {
          newivKeysData.push(input);
        } else {
          newivKeysData.push(oldIv);
        }
      });
      ivData[tranIndex] = newivKeysData;
      scenario[`isCustomIv${tranIndex}`] = false;
    }
    scenario.ivData = ivData;
    this.setState({
      scenarios,
      isDirty: true,
    });
  }
  
  render() {
    
    const {scenarioIndex, scenarios, tranIndex, isIVChart, xAxis, dates, dayRange, sliderRange, isPlay, assetPrice, isDirty, openDate, todayOpenDiffDays, isLoading } = this.state;
    const ivData = scenarioIndex >= 0 ?  (scenarios[scenarioIndex] && scenarios[scenarioIndex].ivData) : [];
    const isFromPositions = this.props.isFromPositions;
    const marks = {
      0: 'Open Date',
      [dayRange]: 'First Expiration',
    };
    const todayDateRange = moment().diff(moment(openDate), 'days');
    if(todayDateRange > 0 && todayDateRange < dayRange) {
      marks[todayDateRange] = 'Today Date'
    }
    if (isLoading) {
      return <Spin className="col" size="large"/>;
    }
    if (isFromPositions) {
      return (
        <div style={{width: '100%'}}>
          <Row>
            <Col span={24}>
              <ChartRisk2
                isIVChart={false}
                scenarios={scenarios}
                xAxis={xAxis}
                isFromPositions={isFromPositions}
                dates={dates}
                assetPrice={assetPrice}
                symbol={(this.state.selectedTrade && this.state.selectedTrade.symbols) || ''}
              />
            </Col>
          </Row>
        </div>
      );
    }
    return (
      <Row>
        <Col span={24}>
          <StyledContent>
            <section>
              <section>
                    <Row gutter={16}>
                      <Col span={18} style={{textAlign: 'right'}}>
                        <a id="downloadChart" />
                        <a id="download" onClick={this.exportChart}><Icon type="download" style={{ marginRight: 10, fontSize: 20, cursor: 'pointer' }}></Icon></a>
                        { isDirty && <Icon type="reload" style={{fontSize: 20, marginRight: 20}} title="If data needs to be refresh then this will be visible, there will also be text that will read. Risk Profile is out of date please click the refresh button." theme="outlined" onClick={this.reloadChart}/> }
                        <ChartRisk2
                          isIVChart={isIVChart}
                          scenarios={scenarios}
                          xAxis={xAxis}
                          dates={dates}
                          assetPrice={assetPrice}
                          symbol={(this.state.selectedTrade && this.state.selectedTrade.symbols) || ''}
                        />
                        <Row>
                          <Col span={1}>
                            { isPlay ? <Icon type="pause-circle" onClick={this.onPause} theme="outlined" style={{fontSize: 20}} /> : <Icon type="play-circle" onClick={this.onPlay} theme="outlined" style={{fontSize: 20}} /> }
                          
                          </Col>
                          <Col span={20}>
                            <Slider min={0} max={dayRange || 0} marks={marks} tipFormatter={this.getTipFormatter} onChange={this.changeSlider} value={sliderRange || 0} />
                          </Col>
                          <Col span={2} style={{paddingTop: 8}}>
                            {moment(this.state.openDate).add(sliderRange || 0, 'days').format('YYYY-MM-DD')}
                          </Col>
                        </Row>
                      </Col>
                      
                      <Col span={6} >
                        <Row>
                          <Col span={24}>
                            <Col span={8}><label>Asset Price</label></Col>
                            <Col span={16}>
                              <Input value={assetPrice}
                                     placeholder="Asset Price"
                                     name={'assetPrice'}
                                     onChange={this.onChangeValues}/>
                            </Col>
                          </Col>
                        </Row>
                        <Collapse accordion >
                          {
                            this.state.scenarios.map((data, i) => (
                              <Panel header={<span>{data.name} <Icon  onClick={(e) => this.removeScenarios(e, i)} className="remove-sce" type="delete" theme="outlined" /></span>} key={i + 1} >
                                <div>
                                  <Input value={data.name}
                                         name="name"
                                         onChange={(e) =>this.onChange(e, i)}
                                         placeholder="Scenario"/>
                                </div>
                                <Card type="inner" title="Target IV">
                                  {
                                    this.state.selectedTrade.transactions.map((tran, index) => (
                                      <Input.Group key={index}>
                                        <Col span={24}>
                                          <Input  style={{ width: 140 }} disabled={data[`isCustomIv${index}`]} value={data[`isCustomIv${index}`] ? 'Custom IV' : data[`values${index}`]} placeholder={`IV ${index}`} name={`values${index}`} onChange={(e) => this.onChange(e, i, index)} />
                                          <Icon style={{fontSize: 20, lineHeight: '32px'}} onClick={() => this.openModal(i, index)} type="setting" theme="outlined" />
                                          <Icon style={{fontSize: 20, lineHeight: '32px', color: '#007bff'}} type={data[`unlock${index}`] ? 'unlock' : 'lock'} onClick={() => this.lockUnlock(!!data[`unlock${index}`], i, index)} theme="outlined" />
                                        </Col>
                                      </Input.Group>
                                    ))
                                  }
                                </Card>
                              </Panel>
                            ))
                          }
                        </Collapse>
                        <div style={{marginTop: 10}}>
                          <Button onClick={this.addScenario}>Add Scenario</Button>
                          <Button onClick={this.toggleChart}>Toggle Chart</Button>
                        </div>
                      </Col>
                    </Row>
                    <TableRiskSelected
                      targetTrade={this.state.tradeRecord}
                      checkedList={this.state.checkedList}
                      onChangeTransactionValues={this.onChangeTransactionValues}
                      onCheckedChange={this.handleCheckedChange} />
                  </section>
            </section>
            <Modal visible={this.state.showModal} footer={null} onCancel={() => this.setState({showModal: false,})}>
              <IvTable onChangeIV={this.onChangeIV} data={ivData && ivData[tranIndex] || []} tranIndex={tranIndex} dates={this.state.dates} todayOpenDiffDays={todayOpenDiffDays} />
            </Modal>
          </StyledContent>
        </Col>
      </Row>
    )
  }
}

export default RiskProfileComponent;


// WEBPACK FOOTER //
// ./src/components/view-trades/risk-profile.js